var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login"},[_c('PageLoader',{attrs:{"text":"Login to BEE-YOND"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }